
const MenuSvg = ({ openNavigation ,toggleNavigation}) => {
  const genericHamburgerLine = `h-[2px] w-6 my-1 rounded-full  dark:bg-gray-100  bg-color-4 transition ease transform duration-300`;
  return (
    <button
      className="flex flex-col hover:opacity-90 h-11 w-11 border-1 border  bg-white dark:bg-color-2 bg-opacity-50 dark:bg-opacity-50  dark:hover:bg-gray-700 dark:border-gray-600 dark:ring-gray-700 border-gray-300 outline-none ring-4 ring-gray-200  rounded-lg justify-center items-center group"
      onClick={ toggleNavigation}
    >
      <div
        className={`${genericHamburgerLine} ${
         openNavigation
            ? "rotate-45 translate-y-3 opacity-100 group-hover:opacity-90"
            : "opacity-100 group-hover:opacity-90"
        }`}
      />
      <div
        className={`${genericHamburgerLine} ${
          openNavigation ? "opacity-0" : "opacity-100 group-hover:opacity-90"
        }`}
      />
      <div
        className={`${genericHamburgerLine} ${
          openNavigation
            ? "-rotate-45 -translate-y-3 opacity-100 group-hover:opacity-90"
            : "opacity-100 group-hover:opacity-90"
        }`}
      />
    </button>
  );
};

export default MenuSvg;
